import { BaseEntityDto } from '../common/base-entity.dto';
import { AdminAlertType, AdminAlertSeverity } from '../../enums';

export interface AdminAlertDto extends BaseEntityDto {
  alertType: AdminAlertType;
  title: string;
  message: string;
  severity: AdminAlertSeverity;
  isRead: boolean;
  isDismissed: boolean;
  dismissedDate?: string | null; // DateTime as ISO string
  dismissedByUserId?: string | null; // Guid
  actionUrl?: string | null;
  metadata: Record<string, unknown>;
}
